export const CHANGE_A = "CHANGE_A";
export const CHANGE_B = "CHANGE_B";
export const CHANGE_C = "CHANGE_C";
export const CHANGE_D = "CHANGE_D";



export const changeChatA = () => ({
  type: CHANGE_A,

});


export const changeChatB = () => ({
  type: CHANGE_B,

});

export const changeChatC = (value) => ({
    type: CHANGE_C,
    payload: value
});

export const changeChatD = (value) => ({
    type: CHANGE_D,
    payload: value
    
});